<template>
  <v-container>
    <h1>Rapportage van alle sessies</h1>
    <v-select
      label="Selecteer jaar"
      :items="jaren"
      v-model="jaar"
      width="100"
    ></v-select>
    <v-btn icon title="Download Excel-file" @click="download()" color="primary"
      ><v-icon x-large>mdi-file-excel-outline</v-icon></v-btn
    >
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      jaren: [],
      jaar: 0,
    };
  },
  methods: {
    download: function () {
      this.$api
        .pRapportTotaal(
          {
            Jaar: this.jaar,
          },
          "excel"
        )
        .then((response) => {
          this.$api.saveDownload(
            response.data,
            "RapportTotaal " + this.jaar.toString() + ".xlsx"
          );
        });
    },
  },
  created: function () {
    this.jaren = [];
    this.jaar = new Date().getFullYear();
    for (var i = 2019; i <= this.jaar; i++) {
      this.jaren.push(i);
    }
  },
};
</script>

<style>
</style>